import * as React from 'react';
import Icon from './Icons';
import InputFieldAddonButton from './InputFieldAddonButton';

type Props = {
  className?: string;
  disabled?: boolean;
  onClick: () => void;
};

export default class ClearFieldButton extends React.Component<Props> {
  render() {
    return (
      <InputFieldAddonButton {...this.props}>
        <Icon.X size={14} />
      </InputFieldAddonButton>
    );
  }
}
